
import React from "react";
import GoogleMapReact from "google-map-react";
import supercluster from "points-cluster";

import mapStyles from "./mapStyles.json";
import MapWrapper from "./MapWrapper";
import { Wrapper, Status } from "@googlemaps/react-wrapper";

import Donut from "../echarts/Donut";

import { postRequest } from "../../services/axiosBaseClient";

const MAP = {
  defaultZoom: 8,
  defaultCenter: { lat: 28.59428, lng: 77.377288 },
  options: {
    maxZoom: 19,
  },
};
var BatteriesData = [];
export class GoogleMap extends React.PureComponent {
  state = {
    mapOptions: {
      center: MAP.defaultCenter,
      zoom: MAP.defaultZoom,
    },
    clusters: [],
    BatteriesData: [],
    loaded: false,
  };

  /*  getMarkersData = async() => {
    await postRequest('bss/batteryCountAndStatusGraph',{}).then((res) => {
      if (res && res?.data) {
        BatteriesData = (res.data).map(function (markerdata) {
          var data = {
            id: markerdata.swappingStationId,
            lat: markerdata.latitude,
            lng: markerdata.longitude,
            swappingStationId: markerdata.swappingStationId,
            swappingStationName: markerdata.swappingStationName,
            charged: markerdata.totalCharged,
            charging: markerdata.totalCharging,
            fault: markerdata.totalFault
          }
          return data;
        });
        this.setState({
          mapOptions: {
            center: BatteriesData.length>0?{lat:BatteriesData[0].lat,lng:BatteriesData[0].lng}:MAP.defaultCenter,
          },
          BatteriesData:BatteriesData,          
          loaded:true
        })
      }
    }).catch((err) => {
      console.error("Error", err)
    })
  }*/
  componentDidMount() {
    BatteriesData = this.props.data;
    this.setState({
      mapOptions: {
        center:
          BatteriesData.length > 0
            ? { lat: BatteriesData[0].lat, lng: BatteriesData[0].lng }
            : MAP.defaultCenter,
      },
      BatteriesData: BatteriesData,
      loaded: true,
    });
  }

  getClusters = () => {
    const clusters = supercluster(this.props.data, {
      minZoom: 0,
      maxZoom: 16,
      radius: 60,
    });

    return clusters(this.state.mapOptions);
  };

  // calcData = (item) => {
  //   let totalIdleIdle = 0;
  //   let totalIdleCharging = 0;

  //   item.points.forEach((element) => {
  //     totalIdleIdle += element.idle;
  //   });

  //   item.points.forEach((element) => {
  //     totalIdleCharging += element.charging;
  //   });
  //   return [
  //     { value: totalIdleIdle, name: "Idle", color: "#087A3E" },
  //     { value: totalIdleCharging, name: "Charging", color: "#FCC644" },
  //   ];
  // };

  calcPointsData = (points, name) => {
    let total = 0;

    points.forEach((element) => {
      total += element[name];
    });
    return total;
  };
  calcSiteName = (points, name) => {
    let total = "";
    points.forEach((element) => {
      total += element[name];
      total+=", "
    });
    return total.slice(0,-2);
  };
  createClusters = (props) => {
    this.setState({
      clusters: this.state.mapOptions.bounds
        ? this.getClusters(props).map(({ wx, wy, numPoints, points }) => ({
            lat: wy,
            lng: wx,
            numPoints,
            id: `${numPoints}_${points[0].id}`,
            points,
          }))
        : [],
    });
  };

  handleMapChange = ({ center, zoom, bounds }) => {
    this.setState(
      {
        mapOptions: {
          center,
          zoom,
          bounds,
        },
      },
      () => {
        //this.getMarkersData();
        this.createClusters(this.props);
      }
    );
  };

  render() {
    var mstyles = { width: "5px", height: "5px" };
    return (
      <MapWrapper>
        {this.state.loaded && (
          <GoogleMapReact
            defaultZoom={MAP.defaultZoom}
            defaultCenter={this.state.mapOptions.center}
            options={MAP.options}
            onChange={this.handleMapChange}
            yesIWantToUseGoogleMapApiInternals
            style={{ width: "100%", height: "500px" }}
            bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
          >
            {this.state.clusters.map((item) => {
              if (item.numPoints === 1) {
                return (
                  <Donut
                    key={item.points[0].id}
                    lat={item.points[0].lat}
                    lng={item.points[0].lng}
                    idle={item.points[0].charged}
                    charging={item.points[0].charging}
                    fault={item.points[0].fault}
                    siteName={item.points[0].siteName}
                    style={mstyles}
                  />
                );
              }

              return (
                <Donut
                  key={item.points[0].id}
                  lat={item.points[0].lat}
                  lng={item.points[0].lng}
                  idle={this.calcPointsData(item.points, "charged")}
                  charging={this.calcPointsData(item.points, "charging")}
                  fault={this.calcPointsData(item.points, "fault")}
                  siteName={this.calcSiteName(item.points, "siteName")}
                  style={mstyles}
                />
              );
            })}
          </GoogleMapReact>
        )}
      </MapWrapper>
    );
  }
}

export default GoogleMap;
